// src/app/rootReducer.js
import { combineReducers } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import userReducer from '../features/user/userSlice';
import announcementReducer from '../features/announcements/announcementSlice'; // Import announcements & holidays reducer

const rootReducer = combineReducers({
    auth: authReducer,
    user: userReducer,
    announcements: announcementReducer, // Add announcements & holidays state
});

export default rootReducer;
